import { report } from "@/utils/urlConstants";

export default ({ get, post, put }) => ({
  getReportList(URL, params) {
    return get(`${report.base}${URL}/`, { params: params });
  },
});
